import { NavLink } from "react-router-dom";
import { useState } from "react";
import "./Header.css";
import logo from "../../images/croped logo-2.png";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="header">
      <nav className="nav">

        {/* LOGO */}
        <NavLink to="/" className="logo" onClick={closeMenu}>
          <img src={logo} alt="Crest Interio Logo" className="logo-img" />
        </NavLink>

        {/* DESKTOP MENU */}
        <div className="nav-right-wrapper">
          <ul className="nav-left">
            <li><NavLink to="/about">ABOUT US</NavLink></li>
            <li><NavLink to="/team">TEAM</NavLink></li>
            <li><NavLink to="/portfolio">PORTFOLIO</NavLink></li>
            <li><NavLink to="/video">VIDEO</NavLink></li>
          </ul>
          <ul className="nav-right">
            <li><NavLink to="/blog">BLOG</NavLink></li>
            {/* <li><NavLink to="/press">PRESS</NavLink></li> */}
            <li>
              <NavLink to="/contact" className="nav-cta">
                GET IN TOUCH
              </NavLink>
            </li>
          </ul>
        </div>

        {/* HAMBURGER */}
        <button
          className={`menu-toggle ${menuOpen ? "open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* MOBILE MENU */}
        <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>
          <ul>
            <li><NavLink to="/about" onClick={closeMenu}>ABOUT US</NavLink></li>
            <li><NavLink to="/team" onClick={closeMenu}>TEAM</NavLink></li>
            <li><NavLink to="/portfolio" onClick={closeMenu}>PORTFOLIO</NavLink></li>
            <li><NavLink to="/video" onClick={closeMenu}>VIDEO</NavLink></li>
            <li><NavLink to="/blog" onClick={closeMenu}>BLOG</NavLink></li>
            {/* <li><NavLink to="/press" onClick={closeMenu}>PRESS</NavLink></li> */}
            <li>
              <NavLink to="/contact" onClick={closeMenu} className="mobile-cta">
                GET IN TOUCH
              </NavLink>
            </li>
          </ul>
        </div>

      </nav>
    </header>
  );
};

export default Header;
